module.exports = __webpack_public_path__ + "img/sprite.dd2de04a.png";